import ServiceModel   from '@models/ServiceModel';
import ApiConnectorV4 from '@/models/ApiConnectorV4';

const service = window.APP_CONFIG.services.find(service => service.id === 'account');

export const accountConnector = new ApiConnectorV4({baseURL: service?.configurations.api_endpoint});

export default class AccountServiceModel extends ServiceModel {
    public static get connector() {
        return accountConnector;
    }

    public static serviceName = 'account';
    public static partitionName = '$';
}
